class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '48db76c8';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1190.0.3';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 19 Aug 2026 16:22:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-08-19 12:22:05 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-08-19 12:22:05 Boston - 48db76c8 - 1190.0.3';
export default BuildTags;
